import { PickerService } from 'app/_services/picker.service';
import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';
import {
    DatePickerComponentOptions,
    DatePickerController,
    DatePickerViewValue,
    DateTimePickerViewValue,
    RuntimePickerViewValue
} from '../custom';

class DatePickerComponentCtrl implements DatePickerController<
    DatePickerViewValue,
    Date
> {
    public readonly INITIAL_VIEW_VALUE: DatePickerViewValue = { date: null };
    public readonly ALT_INPUT_FORMATS = ['d!.M!.yyyy', 'd!.M!.yy'];

    public ngModelCtrl: angular.INgModelController;
    public preSetDayAhead: boolean;

    public dateTimeFormat;
    public datePickerOptions: { minDate: Date; maxDate: Date; startingDay: 1 };
    public gasDayEffectiveRuntimePreSelection: DateInterval;
    public viewValue: DatePickerViewValue;
    public disabled: boolean;
    public preSetDone: boolean;
    public idPrefix: string;

    constructor(
        private $scope: angular.IScope,
        private $element: angular.IRootElementService,
        private pickerService: PickerService,
        private utilService: UtilService
    ) {
        this.dateTimeFormat = this.pickerService.DATE_TIME_FORMAT;
        this.gasDayEffectiveRuntimePreSelection =
            this.pickerService.gasDayEffectiveRuntimePreSelection;
        this.datePickerOptions = {
            maxDate: this.pickerService.maxDate,
            minDate: undefined,
            startingDay: 1
        };
        this.idPrefix = this.utilService.generateGuid(1) + '-';
    }

    $onInit(): void {
        this.$scope.$watch(
            () => this.viewValue,
            () => {
                this.ngModelCtrl.$setViewValue(angular.copy(this.viewValue));

                if (!this.preSetDone) {
                    this.ngModelCtrl.$setPristine();
                    this.ngModelCtrl.$setUntouched();
                    this.preSetDone = true;
                }
            },
            true
        );

        this.$scope.$watch(
            () => this.$element[0].hasAttribute('disabled'),
            (hasDisabledAttribute) => (this.disabled = hasDisabledAttribute)
        );

        this.ngModelCtrl.$isEmpty = (
            viewValue: RuntimePickerViewValue
        ): boolean => {
            return angular.equals(viewValue, this.INITIAL_VIEW_VALUE);
        };

        this.ngModelCtrl.$parsers.push(
            (viewValue: DateTimePickerViewValue): Date => {
                if (this.ngModelCtrl.$isEmpty(viewValue)) {
                    return null;
                }

                return this.pickerService.parseViewValue(viewValue);
            }
        );

        this.ngModelCtrl.$render = () => {
            this.preSet(this.ngModelCtrl.$modelValue);
        };
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.datePickerOptions.minDate =
            !angular.isUndefined(onChangesObj['minDate']) &&
            onChangesObj['minDate'].currentValue;

        if (!angular.isUndefined(onChangesObj['preSetDayAhead'])) {
            this.preSetDayAhead = onChangesObj['preSetDayAhead'].currentValue;
            this.preSet();
        }
    }

    preSet(modelValueToPreSetTo?: Date): void {
        const viewValue = <DatePickerViewValue>{};
        const dateTimeKeys: (keyof DateTimePickerViewValue)[] = [
            'date',
            'time'
        ];

        for (let dateOrTime of dateTimeKeys) {
            viewValue[dateOrTime] = this.pickerService.preSet(
                dateOrTime,
                this.INITIAL_VIEW_VALUE[dateOrTime],
                this.preSetDayAhead,
                modelValueToPreSetTo
            );
        }

        this.viewValue = viewValue;
    }
}

angular.module('app').component('pkpDatePicker', <DatePickerComponentOptions>{
    controller: DatePickerComponentCtrl,
    template: require('app/_directives/date-picker.component.html'),
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {
        preSetDayAhead: '<',
        minDate: '<'
    }
});
